import { render, staticRenderFns } from "./CtaVideo.vue?vue&type=template&id=b412df64&scoped=true&"
import script from "./CtaVideo.vue?vue&type=script&lang=js&"
export * from "./CtaVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b412df64",
  null
  
)

export default component.exports